<template>
  <div>
    <app-header title="Device Categories">
      <b-button v-router-link="{ name: 'devicecategory-editor', params: { id:'new' }}" variant="primary">
        <i class="fa fa-plus-circle" /> New Device Category
      </b-button>
    </app-header>
    <loading-spinner v-if="!devicecategories" />
    <b-container v-else>
      <b-row>
        <b-col>
          <search-input v-model="query" />
        </b-col>
        <b-col class="text-right">
          {{ total }} Device Categories
        </b-col>
      </b-row>
      <b-card-group columns>
        <!--  | filter : query -->
        <b-card no-body
          v-for="devicecategory in displayDevicecategories"
          :key="devicecategory.id"
          v-router-link="{name:'devicecategory-detail',params:devicecategory}"
        >
          <img :src="'https://cdn.gokaizen.com/' + devicecategory.src" alt="" style="max-width:100%;">
          <b-card-body>
            <h3>{{ devicecategory.name }}</h3>
          </b-card-body>
        </b-card>
      </b-card-group>
      <infinite-scrolling @infiniteHandler="infiniteHandler" />
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import $search from '@/services/search';
import SearchInput from '@/components/SearchInput';
import LoadingSpinner from '@/components/LoadingSpinner';
import InfiniteScrolling from '@/components/InfiniteScrolling';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    AppHeader,
    SearchInput,
    LoadingSpinner,
    InfiniteScrolling,
  },

  data() {
    return {
      query: '',
      devicecategories: null,
      page: 0,
      perPage: 7,
    };
  },

  computed: {
    displayDevicecategories() {
      return $search(this.devicecategories, this.query).slice(0, this.perPage * this.page);
    },

    total() {
      return (this.query) ? this.displayDevicecategories.length : this.devicecategories.length;
    },
  },

  created() {
    this.refreshData();
  },

  methods: {
    async refreshData() {
      this.devicecategories = await $api.get('/v1/internal/devicecategories');
    },

    infiniteHandler($state) {
      if ((this.perPage * this.page) <= this.devicecategories.length) {
        this.page += 1;
        $state.loaded();
      } else {
        $state.complete();
      }
    },
  },
};
</script>
